import { SHOULD_HIDE_BACK_BUTTONS, SHOULD_HIDE_SWITCH_OFFER } from '@/common/constants'
import store from '../store'

const backButtonNavigationMixin = {
  data: () => ({
    showBackButton: true
  }),
  methods: {
    setShowBackButton (flag) { this.showBackButton = flag }
  },
  async created () {
    const shouldHideButton = !!(await store.get(SHOULD_HIDE_BACK_BUTTONS))
    if (shouldHideButton) this.setShowBackButton(false)
  }
}

const switchOfferNavigationMixin = {
  data: () => ({
    showSwitchOffer: true
  }),
  methods: {
    setShowSwitchOffer (flag) { this.showSwitchOffer = flag }
  },
  async created () {
    const shouldHideButton = !!(await store.get(SHOULD_HIDE_SWITCH_OFFER))
    if (shouldHideButton) this.setShowSwitchOffer(false)
  }
}

export { backButtonNavigationMixin, switchOfferNavigationMixin }
